import { type FileTag } from "@/lib/api";

interface TagChipProps {
  tag: FileTag | null;
  size?: "sm" | "md";
}

export function TagChip({ tag, size = "md" }: TagChipProps) {
  const colors: Record<FileTag | "null", { bg: string; text: string }> = {
    main_scope: {
      bg: "rgba(249,115,22,0.15)",
      text: "#F97316",
    },
    addendum: {
      bg: "rgba(234,179,8,0.15)",
      text: "#EAB308",
    },
    qa: {
      bg: "rgba(59,130,246,0.15)",
      text: "#60A5FA",
    },
    evaluation: {
      bg: "rgba(168,85,247,0.15)",
      text: "#A855F7",
    },
    reference: {
      bg: "rgba(156,163,175,0.15)",
      text: "#9CA3AF",
    },
    null: {
      bg: "rgba(107,114,128,0.1)",
      text: "#9CA3AF",
    },
  };

  const labels: Record<FileTag | "null", string> = {
    main_scope: "Main scope",
    addendum: "Addendum",
    qa: "Q&A clarifications",
    evaluation: "Evaluation criteria",
    reference: "Reference document",
    null: "Classifying…",
  };

  const key = tag ?? "null";
  const color = colors[key];
  const label = labels[key];

  const sizeClasses = size === "sm" ? "px-2 py-1 text-xs" : "px-3 py-1.5 text-xs";

  return (
    <span
      className={`inline-block rounded-full font-medium whitespace-nowrap ${sizeClasses}`}
      style={{
        backgroundColor: color.bg,
        color: color.text,
      }}
    >
      {label}
    </span>
  );
}
